import { Link } from 'react-router-dom';
import './Button.css';

/* ─────────────────────────────────────────────────────────────
   BUTTON — Reusable button/link component.

   Props:
   - variant: 'primary' | 'ghost' | 'outline'  (default: 'primary')
   - size:    'sm' | 'md' | 'lg'               (default: 'md')
   - href:    string  → renders as <a href="...">  (anchor or external)
   - to:      string  → renders as React Router <Link to="...">
   - onClick: fn      → renders as <button>
   - type:    'button' | 'submit'               (default: 'button')
   - fullWidth: bool  → stretches to fill container (default: false)
   - children: the button label/content

   Only provide one of: href, to, or onClick.
   ───────────────────────────────────────────────────────────── */
function Button({
  variant = 'primary',
  size = 'md',
  href,
  to,
  onClick,
  type = 'button',
  fullWidth = false,
  disabled = false,
  children,
  className = '',
}) {
  const classes = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    fullWidth ? 'btn-full' : '',
    className,
  ].filter(Boolean).join(' ');

  // Render as a React Router link (internal navigation, no page reload)
  if (to) {
    return <Link to={to} className={classes}>{children}</Link>;
  }

  // Render as a plain anchor (hash links, external links)
  if (href) {
    return <a href={href} className={classes}>{children}</a>;
  }

  // Render as a button element (form submits, click handlers)
  return (
    <button type={type} className={classes} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

export default Button;
